<template>
<div class="sidebar main-sidebar">
	<h1>Explore IRYS</h1>
	<grid flat class="tabs-caption">
		<grid-item size="1/2">
			<h3 class="pos-left" :class="activeTab == 0 ? 'active' : ''" @click="activeTab = 0">Opportunities</h3>
		</grid-item>
		<grid-item size="1/2">
			<h3 class="pos-right" :class="activeTab == 1 ? 'active' : ''" @click="activeTab = 1">Companies</h3>
		</grid-item>
	</grid>
	<grid flat class="tabs-content" v-if="activeTab == 0">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Search by Sector"
				:itemList="sectors"
				itemValue="id"
				v-model="selectedSectors"
			/>
			<custom-multiple-select
				label="Search by Region"
				:itemList="regions"
				itemValue="id"
				v-model="selectedRegions"
			/>
			<custom-input
				type="text"
				placeholder="Keyword Search"
				inputStyle="dark"
				v-model="keyWordValue"
			/>
			<sidebar-additional-criteria label="Additional Search Criteria" :itemList="additionalCriteriaList"/>
			<hr>
			<button class="button primary isDisabled"
				ref="opportunitySearchButton"
				@click="search()"
				v-text="'View on map'"
			/>
		</grid-item>
	</grid>
	<grid class="tabs-content" v-if="activeTab == 1">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Search by Sector"
				:itemList="sectors"
				itemValue="id"
				v-model="selectedSectors"
			/>
			<custom-multiple-select
				label="Search by Region"
				:itemList="regions"
				itemValue="id"
				v-model="selectedRegions"
			/>
			<custom-input
				type="text"
				placeholder="Keyword Search"
				inputStyle="dark"
				v-model="keyWordValue"
			/>
			<sidebar-additional-criteria label="Additional Search Criteria" :itemList="additionalCriteriaList"/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
</div>
</template>

<script>
import CustomMultipleSelect from '@/components/secondary/CustomMultipleSelect'
import CustomInput from '@/components/secondary/CustomInput'
import SidebarAdditionalCriteria from '@/components/secondary/SidebarAdditionalCriteria'
import { mapActions, mapState } from 'vuex'

export default {
	components: {
		CustomMultipleSelect,
		CustomInput,
		SidebarAdditionalCriteria
	},
	data: () => ({
		activeTab: 0,
		selectedSectors: [],
		selectedRegions: [],
		keyWordValue: null,
		additionalCriteriaList: [
			{name: 'Pre-feasibility study', status: false},
			{name: 'Free zone / special economic zone', status: false},
			{name: 'Opportunity with land', status: false},
			{name: 'Land only', status: false},
			{name: 'ppp', status: false}
		]
	}),
	computed: {
		...mapState({
			sectors: ({ SectorStore }) => {
				let total = 0
				let items = SectorStore.list.map(item => {
					total += item.count
					item.name = item.name + ' (' + item.count + ')'
					item.disabled = (item.count < 1)
					return item
				})
				items.unshift({
					id: 0,
					name: 'All (' + total + ')',
					disabled: false
				})
				return items
			},
			regions: ({ RegionStore }) => {
				let total = 0
				let items = RegionStore.list.map(item => {
					total += item.count
					item.name = item.name + ' (' + item.count + ')'
					item.disabled = (item.count < 1)
					return item
				})
				items.unshift({
					id: 0,
					name: 'All (' + total + ')',
					disabled: false
				})
				return items
			},
		})
	},
	mounted() {
		this.getSectors()
		this.getRegions()
	},
	methods: {
		...mapActions({
			getSectors: 'SectorStore/getList',
			getRegions: 'RegionStore/getList'
		}),
		search() {
			this.$router.push({
				name: 'opportunity-list',
				query: {
					...this.$route.query,
					sectorId: this.selectedSectors,
					regionId: this.selectedRegions,
					name_like: this.keyWordValue
				}
			})
		},
		checkSearch() {
			if(
				this.selectedSectors.length > 0 ||
				this.selectedRegions.length > 0 ||
				(this.keyWordValue != '' && this.keyWordValue != undefined)
			) {
				this.$refs.opportunitySearchButton.classList.remove('isDisabled')
			} else {
				this.$refs.opportunitySearchButton.classList.add('isDisabled')
			}
		}
	},
	watch: {
		selectedSectors() {
			this.checkSearch()
		},
		selectedRegions() {
			this.checkSearch()
		},
		keyWordValue() {
			this.checkSearch()
		}
	}
}
</script>

<style lang="scss">
.main-sidebar {
	clear: both;
	float: right;
	margin-right: 28px;
	z-index: 2;
	position: absolute;
	top: 53px;
	right: 0;

	h1 {
		font-size: 26px;
		color: #fff;
		font-weight: 700;
		text-transform: uppercase;
		text-align: left;
		user-select: none;
		margin-top: 8px;
		margin-bottom: 26px;
	}

	hr {
		margin: 20px 0px 15px;
		float: left;
		margin-left: -10%;
		width: 120%;
		border: none;
		border-top: 1px solid #949594;
	}

	.tabs-caption {
		border-bottom: 2px solid #4ba98b;
		margin-bottom: 4px;

		h3 {
			margin: 0;
			color: #fff;
			text-transform: uppercase;
			font-size: 10px;
			background: linear-gradient(to bottom, #181e24 50%, #1e262d 50%);
			border: 2px solid #1e262d;
			padding: 10px;
			border-bottom: 0 !important;
			border-top-left-radius: 20px;
			border-top-right-radius: 20px;
			font-weight: 500;
			cursor: pointer;
			user-select: none;
			width: 125px;
			box-sizing: border-box;

			&:hover {
				background: linear-gradient(to bottom, #54b1d7 50%, #3b9fce 50%);
				border: 2px solid #3b9fce;
			}
		}
		h3.active {
			background: linear-gradient(to bottom, #5eb9a2 50%, #4ba98b 50%);
			border: 2px solid #4ba98b;

			&:hover {
				background: #4ba98b;
			}
		}
	}

	.button {
		width: auto;
	}
}
</style>
